import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PlatformService } from '../universal';
import { NavigationService } from './navigation.service';
import { PhxPendingHttpTasks } from './phx-pending-http-tasks.service';

@Injectable()
export class CustomStabilizationHttpInterceptor implements HttpInterceptor {
    constructor(
        private navigationService: NavigationService,
        private platform: PlatformService,
        private pendingHttpTasks: PhxPendingHttpTasks
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.platform.isServer || request.url.endsWith('/log')) {
            return next.handle(request);
        }

        // All HTTP requests make the Angular app unstable (except /log calls)
        const taskId = this.pendingHttpTasks.add();
        this.navigationService.isStable$.next(false);

        // After the response we wait until it is stable again (all HTTP requests are done)
        return next.handle(request).pipe(
            tap({
                finalize: () => {
                    this.pendingHttpTasks.remove(taskId);
                    this.navigationService.startCustomStabilizationCheck();
                }
            })
        );
    }
}
